<template>
  <component
    :is="to ? 'router-link' : 'div'"
    class="chat-content-channel"
    :to="to"
  >
    <div class="chat-content-channel__image">
      <slot name="image" />
    </div>

    <div class="chat-content-channel__center">
      <div class="chat-content-channel__title">
        {{ title }}
      </div>

      <div class="chat-content-channel__description">
        {{ description }}
      </div>
    </div>

    <div class="chat-content-channel__right-icon">
      <tm-button
        flat
        icon-only
        color="transparent"
      >
        <tm-icon
          class="neutral--text"
          name="tmi-chevron-right"
        />
      </tm-button>
    </div>
  </component>
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'
import TmButton from '@/components/shared/TmButton.vue'
import TmIcon from '@/components/shared/TmIcon.vue'

defineProps<{
  to?: RouteLocationRaw
  title: string
  description: string
}>()
</script>

<style lang="scss" scoped>
.chat-content-channel {
  text-align: left;
  display: flex;
  align-items: center;
  color: $emphasize;
  gap: 12px;
  padding: 12px;
  background: $white;
  border-radius: $border-radius-md;
  border: 1px solid $gray2;
  cursor: pointer;

  &__image {
    flex-shrink: 0;
    flex-grow: 0;
    align-self: flex-start;
    display: flex;
    align-items: center;
    border-radius: $border-radius-md;
    justify-content: center;
    border: 1px solid $gray2;
    width: 44px;
    height: 44px;
  }

  &__center {
    flex-grow: 1;
    flex-shrink: 1;
    min-width: 0;
  }

  &__title {
    font-size: 15px;
    font-weight: $bold-font;
    line-height: 24px;
    word-break: break-word;
  }

  &__description {
    font-size: 13px;
    font-weight: $regular-font;
    line-height: 20px;
    color: $neutral;
  }

  &__right-icon {
    flex-shrink: 0;
    flex-grow: 0;
  }

  &:hover {
    .chat-content-channel__title {
      color: $blue;
    }
  }
}
</style>
